<section id="staking-section" class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-10 animate-fade-in">
  <div class="card p-8 border-gold/25 bg-gold/[0.01]">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
      <div>
        <h3 class="font-display font-black text-2xl text-white uppercase tracking-wider">Ecosystem Staking Pools</h3>
        <p class="text-text-muted text-[13.5px] mt-1.5">Maximize returns by staking native assets inside secure
          governance contract pools.</p>
      </div>
    </div>

    <!-- Table Header (Desktop) -->
    <div class="hidden md:grid grid-cols-4 gap-4 px-6 py-3 border-b border-white/[0.04] text-[12px] font-bold text-text-dim uppercase tracking-wider mb-2">
      <div class="col-span-1">Pool</div>
      <div class="col-span-1">Total Staked (TVL)</div>
      <div class="col-span-1">Annual Reward APR</div>
      <div class="col-span-1 text-right pr-4">Action</div>
    </div>

    <!-- Table Body -->
    <div class="flex flex-col">
      @for (pool of state.stakingPools(); track pool.name) {
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 px-6 py-5 border-b border-white/[0.02] hover:bg-white/[0.02] transition-colors items-center group">
        
        <!-- Pool Info -->
        <div class="col-span-1 flex items-center gap-3">
          <div class="w-10 h-10 rounded-full flex items-center justify-center text-[13px] font-bold text-white shadow-md relative border-[2px] border-[#0c0c0c]"
            [style.background]="pool.tokenColor">
            @if (pool.logoUrl) {
              <img [src]="pool.logoUrl" class="w-full h-full rounded-full object-cover">
            } @else {
              <ng-container>{{ pool.tokenSymbol.charAt(0) }}</ng-container>
            }
          </div>
          <div>
            <div class="text-[15px] font-bold text-white mb-0.5">{{ pool.name }}</div>
            <div class="text-[12px] text-text-dim flex items-center gap-1.5">
              Stake {{ pool.tokenSymbol }}
            </div>
          </div>
        </div>

        <!-- TVL -->
        <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
          <span class="md:hidden text-[12px] font-bold text-text-dim">TVL</span>
          <span class="text-[14px] font-bold text-white">{{ pool.tvl }}</span>
        </div>

        <!-- APR -->
        <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
          <span class="md:hidden text-[12px] font-bold text-text-dim">APR</span>
          <span class="text-[15px] font-black text-gold">{{ pool.apr }}%</span>
        </div>

        <!-- Action -->
        <div class="col-span-1 flex justify-end">
          <button (click)="state.openStakingModal(pool)"
            class="btn-gold px-6 py-2 rounded-xl text-[12px] font-bold tracking-wider uppercase opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-all duration-200">
            Stake Now
          </button>
        </div>
        
      </div>
      }
    </div>
  </div>
</section>
